module.exports = __webpack_public_path__ + "img/ellipse_half_blue_small.4887f731.png";